import Vue from 'vue'
import VueRouter from 'vue-router'
import buyPage from '../views/buyPage.vue'
import buyOverview from '../views/buyOverview.vue'
import sendPage from '../views/sendPage.vue'
import login from '../views/login.vue'
import sendPage_detail from '../views/sendPage_detail.vue'
import printout from '../views/printout.vue'
import desktop from '@/views/desktop'
import userManager from '@/views/userManager'
import proc from '../views/proc/proc.vue'
import proc_detail from '../views/proc/proc_detail.vue'
import procSend from '../views/proc/procSend.vue'
import procSend_detail from '../views/proc/procSend_detail.vue'
import procSendLabel from '../views/proc/procSendLabel.vue'
import procUser from '../views/proc/procUser.vue'
import fileManage from '../views/fileManage.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/buyOverview',
    name: 'buyOverview',
    component: buyOverview,
    meta: { requiresAuth: true, title: '采购订单（总览）' }, // 需要登录才能访问
  },
  {
    path: '/buyPage',
    name: 'buyPage',
    component: buyPage,
    meta: { requiresAuth: true, title: '采购订单（明细）' }, // 需要登录才能访问
  },
  {
    path: '/login',
    name: 'login',
    component: login
  },
  {
    path: '/',
    name: 'desktop',
    component: desktop,
    meta: { requiresAuth: true, title: '首页' }, // 需要登录才能访问
  },
  {
    path: '/userManager',
    name: 'userManager',
    component: userManager,
    meta: { requiresAuth: true, title: '供应商门户' }, // 需要登录才能访问
  },
  {
    path: '/sendPage',
    name: 'sendPage',
    component: sendPage,
    meta: { requiresAuth: true, title: '送货单' }, // 需要登录才能访问
  },
  {
    path: '/sendPage_detail',
    name: 'sendPage_detail',
    component: sendPage_detail,
    meta: { requiresAuth: true, title: '送货单明细' },
  },
  {
    path: '/printout',
    name: 'printout',
    component: printout,
    meta: { requiresAuth: true },
  },
  {
    path: '/proc',
    name: 'proc',
    component: proc,
    meta: { requiresAuth: true, title: '加工单（总览）' }, // 需要登录才能访问
  },
  {
    path: '/proc_detail',
    name: 'proc_detail',
    component: proc_detail,
    meta: { requiresAuth: true, title: '加工单（明细）' }, // 需要登录才能访问
  },
  {
    path: '/procSend',
    name: 'procSend',
    component: procSend,
    meta: { requiresAuth: true, title: '加工送货单（总览）' }, // 需要登录才能访问
  },
  {
    path: '/procSend_detail',
    name: 'procSend_detail',
    component: procSend_detail,
    meta: { requiresAuth: true, title: '加工送货单（明细）' }, // 需要登录才能访问
  },
  {
    path: '/procSendLabel',
    name: 'procSendLabel',
    component: procSendLabel,
    meta: { requiresAuth: true, title: '物料标识卡' }, // 需要登录才能访问
  },
  {
    path: '/procUser',
    name: 'procUser',
    component: procUser,
    meta: { requiresAuth: true, title: '加工商门户' }, // 需要登录才能访问
  },
  {
    path: '/fileManage',
    name: 'fileManage',
    component: fileManage,
    meta: { requiresAuth: true, title: '文件管理' }, // 需要登录才能访问
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
})

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }
  if (to.matched.some(record => record.meta.requiresAuth)) { // 判断该路由是否需要登录权限
    if (!sessionStorage.getItem('token')) { // 判断当前用户的登录信息是否存在
      next({
        path: '/login',
      })
    } else {
      next()
    }
  } else {
    next()
  }
})

export default router
